import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import {
  BaseText,
  HeadingDisplay,
  Row,
  BaseIcon
} from '@warrenbrasil/nebraska-web';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { RLPPageData, RLPStatusColors } from '@/modules/trade/services/rlp';

interface Props {
  pageData: RLPPageData;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    pageData: null
  },
  setup(__props: any) {

const props = __props as {
  pageData: RLPPageData;
};



const iconColor = computed(() => {
  if (props.pageData.summary.header.status.color === RLPStatusColors.positive) {
    return NebraskaColors.statusPositive;
  }
  return NebraskaColors.elementPrimary;
});

return { __sfc: true,props, iconColor, BaseText, HeadingDisplay, Row, BaseIcon, NebraskaColors }
}

})